export const MARKETS = Object.freeze([
    Object.freeze({ id: 'btc-usd', symbol: 'BTC/USD', pairId: 1, feedId: '0xe62df6c8b4a85fe1a67db44dc12de5db330f7ac66b72dc658afedf0f4a415b43', chain: 'bsc', pricePath: '/gridy/prices/bsc/1', bandHeight: Object.freeze({ coefficient: '1', exponent: 1 }) }),
    Object.freeze({ id: 'eth-usd', symbol: 'ETH/USD', pairId: 2, feedId: '0xff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace', chain: 'bsc', pricePath: '/gridy/prices/bsc/2', bandHeight: Object.freeze({ coefficient: '5', exponent: -1 }) })
]);
export const DEMO_CONFIG = Object.freeze({
    productName: 'TapEX', mode: 'paper-demo', currency: 'USD',
    markets: MARKETS, initialMarketId: 'btc-usd',
    publicDataBaseUrl: 'https://gridy-server-556168718513.us-central1.run.app',
    configPath: '/gridy/config/bsc',
    probabilityTableUrl: 'https://storage.googleapis.com/lynx-gameroom-public/pricing/gridy-touch-table.json',
    stakeMenuCents: Object.freeze(['10', '50', '100', '500', '1000']),
    initialStakeCents: '100', maxStakePerBetCents: '1000', maxAcceptedStakePerCellCents: '5000',
    startingBalanceCents: '100000', refillCents: '100000', maxNewBetsPerPage: 10,
    zoom: Object.freeze({ min: 0.345, max: 0.9, initial: 0.6, inFactor: 1.1, outFactor: 0.9 }),
    /**
     * Presentation only. Trailing 60 s range of the first-seen path in band heights: below quietEnter the chart eases
     * to quietZoom and stays until the range exceeds quietExit; above busyEnter it eases to busyZoom until the range
     * falls below busyExit; leaving either regime returns to the initial zoom. Any manual zoom or pinch turns it off.
     */
    autoZoom: Object.freeze({ windowMs: 60_000, minSamples: 30, quietEnterBands: 0.3, quietExitBands: 0.6, busyEnterBands: 2, busyExitBands: 1.5, quietZoom: 0.9, busyZoom: 0.5, easeMs: 2000, minDwellMs: 10_000 }),
    /** Paper odds from our own market log (tooling/calibrate/fit-paper.mjs): one hashed file per market under this path. */
    calibration: Object.freeze({ path: '/calibration/', modelId: 'maya-gaussian-linear-six-v2+hist-cal-v1' }),
    /** Price buffers carry the same Pyth feed id whether the relay reads it through Lynx (BSC) or Pyth Hermes (Pythnet). */
    acceptedPriceChains: Object.freeze(['bsc', 'pythnet']),
    windowMs: 5000, gridDivisor: 6, ruleVersion: 'maya-observed-linear-v2',
    consultationUrl: 'https://quantellics.com/launch-review/', consultationTitle: 'Launch TapEX under your brand',
    consultationBody: "You've placed 10 demo bets. Book a consultation to purchase TapEX as your white-label trading game. We'll customise it for your business, launch it for you and hand over the full project source code.",
    consultationAction: 'Book a consultation', consultationSecondary: 'View my results',
    consultationSupport: 'Your current bets will finish while this page stays open. Refresh for a fresh $1,000 balance and 10 new demo bets.'
});
export function getMarket(marketId) {
    const market = MARKETS.find(item => item.id === marketId);
    if (!market)
        throw new RangeError('Unsupported TapEX market');
    return market;
}
export function clampZoom(zoom) {
    if (!Number.isFinite(zoom))
        throw new RangeError('Invalid zoom');
    return Math.min(DEMO_CONFIG.zoom.max, Math.max(DEMO_CONFIG.zoom.min, zoom));
}
export function stepZoom(zoom, direction) { return clampZoom(zoom * (direction === 'in' ? DEMO_CONFIG.zoom.inFactor : DEMO_CONFIG.zoom.outFactor)); }
export function stepStake(stakeCents, direction) {
    const i = DEMO_CONFIG.stakeMenuCents.indexOf(stakeCents);
    if (i < 0)
        throw new RangeError('Unsupported stake');
    return DEMO_CONFIG.stakeMenuCents[Math.min(DEMO_CONFIG.stakeMenuCents.length - 1, Math.max(0, i + (direction === 'up' ? 1 : -1)))];
}
//# sourceMappingURL=demo.js.map